import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// components
import Image from '../../../tools/image/Image';
import VideoModal from '../../../layouts/modal/videoModal/VideoModal';

// actions
import modalActions from '../../../../actions/modal';

// Props
const propTypes = {
  active: PropTypes.bool.isRequired,
  changeCurrentImage: PropTypes.func.isRequired,
  media: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired,
};

const defaultProps = {};

function ImageGalleryThumbnail(props) {
  const { active, changeCurrentImage, media, showModal } = props;
  const thumbnailAction = {
    image: () => changeCurrentImage(media),
    video: () => showModal(
      VideoModal,
      { video: media.video },
    ),
  };
  return (
    <li>
      <button
        className={classNames(
          'image-gallery__thumbnail', {
          'image-gallery__thumbnail--active': active,
          'image-gallery__thumbnail--video': media.mediaType === 'video',
        })}
        onClick={thumbnailAction[media.mediaType]}
      >
        {media.mediaType === 'video' &&
          <div className="image-gallery__thumbnail__play">
            <span />
          </div>
        }
        <Image
          alt={media.alt}
          mediaUrl={media.thumbnail}
          placeholder="unavailable"
        />
      </button>
    </li>
  );
}

ImageGalleryThumbnail.propTypes = propTypes;
ImageGalleryThumbnail.defaultProps = defaultProps;

export default connect(null, modalActions)(ImageGalleryThumbnail);



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/imageGallery/ImageGalleryThumbnail.js